module.exports = __webpack_public_path__ + "static/media/defaultCover.aa5e8cb5.jpg";